import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { LEVELS } from "../data/levels";
import { useEffect } from "react";
import { get } from "../../../http/api";
import { useState } from "react";
import { useTranslation } from "react-i18next";


export default function ClubForm() {
    const { handleChange, handleDetailsChange, formData, fieldErrors, setLegalForm,
        countries, setFootballCountry, setDetails, leagues, setLeague, setLeagues, footballCountry,
        details, PHONE_RULES, passwordStrength } = useRegister();

    const [loadingLeagues, setLoadingLeagues] = useState(false);

    const isAmateur = details.level === "Amateur";

    const isProfessional =
        [
            "Semi-pro",
            "Professionnel",
            "Élite"
        ].includes(details.level);

    const { t } = useTranslation();

    useEffect(() => {
        if (!footballCountry || !isProfessional) return;

        const fetchLeagues = async () => {
            setLoadingLeagues(true);
            setLeagues([]);

            try {
                const res = await get(
                    `football/leagues?country=${encodeURIComponent(footballCountry)}`
                );
                setLeagues(res.data || []);
            } catch {
                setLeagues([]);
            } finally {
                setLoadingLeagues(false);
            }
        };

        fetchLeagues();
    }, [footballCountry, details.level]);



    return (
        <form className="register-form-grid">
            <>
                <div className="input-wrapper">
                    <input
                        required
                        className={`register-inputs ${fieldErrors.username ? "input-error" : ""}`}
                        name="username"
                        value={formData.username}
                        placeholder={
                            t("athleteForm.username")
                        }
                        onChange={handleChange}
                    />

                    {fieldErrors.username && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.username}
                        </div>
                    )}
                </div>
                <input
                    className='register-inputs'
                    placeholder={
                        t("clubForm.clubName")
                    }
                    name='club_name'
                    value={details.club_name}
                    onChange={handleDetailsChange}
                    required
                />

                <div className="input-wrapper">
                    <input
                        className={`register-inputs ${fieldErrors.email ? "input-error" : ""}`}
                        name="email"
                        type="email"
                        autoComplete="new-email"
                        value={formData.email}
                        placeholder={
                            t("athleteForm.email")
                        }
                        onChange={handleChange}
                        required
                    />

                    {fieldErrors.email && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.email}
                        </div>
                    )}
                </div>

                <div className="input-wrapper">
                    <input
                        className={`register-inputs ${fieldErrors.password
                            ? "input-error"
                            : passwordStrength.valid
                                ? "input-success"
                                : ""
                            }`}
                        type="password"
                        required
                        name="password"
                        autoComplete="new-password"
                        placeholder={
                            t("athleteForm.password")
                        }
                        value={formData.password || ""}
                        onChange={handleChange}
                    />

                    {formData.password && (
                        <>
                            <div className="password-strength-bar">
                                <span
                                    style={{
                                        width: `${passwordStrength.score * 20}%`,
                                    }}
                                    className={
                                        passwordStrength.score <= 2
                                            ? "weak"
                                            : passwordStrength.score <= 4
                                                ? "medium"
                                                : "strong"
                                    }
                                />
                            </div>

                            <small className="password-message">
                                {passwordStrength.message}
                            </small>
                        </>
                    )}
                </div>



                <input
                    className='register-inputs'
                    placeholder={
                        t("athleteForm.address")
                    }
                    name='address'
                    value={formData.address}
                    onChange={handleChange}
                    required
                />
                <input className='register-inputs' name='creation_date' value={details.creation_date} type="date" onChange={handleDetailsChange} required />


                <select className='register-select' name="legal_form" value={details.legal_form} onChange={(e) => { setLegalForm(e.target.value); handleDetailsChange(e) }} required>
                    <option value="">{t("clubForm.legalForm")}</option>
                    <option value="societe">{t("clubForm.company")}</option>
                    <option value="association">{t("clubForm.association")}</option>
                    <option value="institution">{t("clubForm.institution")}</option>
                </select>

                <SearchableCountrySelect
                    className="register-select"
                    name="country"
                    value={formData.country || ""}
                    required
                    onChange={(e) => {
                        const value = e.target.value;

                        handleChange(e);
                        // setCountry(value);
                        setDetails(prev => ({
                            ...prev,
                            league_id: null,
                            league_name: null,
                            season: null,
                        }));

                        // setLeagues([]);
                    }}
                >
                    <option value="">{t("athleteForm.country")}</option>

                    {countries.map((country) => (
                        <option
                            key={country.code}
                            value={country.name}
                        >
                            {country.flag} {country.name}
                        </option>
                    ))}
                </SearchableCountrySelect>

                <select
                    required
                    className="register-select"
                    name="language"
                    value={formData.language}
                    onChange={handleChange}
                >

                    <option value="">
                        {t("athleteForm.language")}
                    </option>

                    <option value="fr">
                        🇫🇷 Français
                    </option>

                    <option value="en">
                        🇬🇧 English
                    </option>

                    <option value="ar">
                        🇲🇦 العربية
                    </option>

                    <option value="es">
                        🇪🇸 Español
                    </option>
                    <option value="pt">🇵🇹 Português</option>
                    <option value="zh">🇨🇳 中文（简体）</option>
                    <option value="de">🇩🇪 Deutsch</option>
                    <option value="ru">🇷🇺 Русский</option>
                    <option value="it">🇮🇹 Italiano</option>
                    <option value="sr">🇷🇸 Srpski</option>

                </select>


                <div className="input-wrapper">
                    <input
                        required
                        className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
                            }`}
                        name="phone"
                        value={formData.phone || ""}
                        placeholder={
                            PHONE_RULES[formData.country]?.placeholder ||
                            t("athleteForm.phone")
                        }
                        onChange={handleChange}
                    />

                    {fieldErrors.phone && (
                        <div className="error-message">
                            <span className="error-icon">✖</span>
                            {fieldErrors.phone}
                        </div>
                    )}
                </div>


                <select
                    className='register-select'
                    name='sport'
                    onChange={handleDetailsChange}
                    required
                >
                    <option value="">
                        {t("athleteForm.sport")}
                    </option>

                    <option value="Football">
                        {t("athleteForm.football")}
                    </option>

                    <option disabled style={{ color: "#999" }}>
                        {t("athleteForm.basketSoon")}
                    </option>

                    <option disabled style={{ color: "#999" }}>
                        {t("athleteForm.handballSoon")}
                    </option>
                </select>

                <select required className='register-select' name='level' value={details.level || ""} onChange={handleDetailsChange} >
                    <option value="">
                        {t("athleteForm.level")}
                    </option>
                    {LEVELS.map((l) => (
                        <option key={l.value} value={l.value}>{t(l.label)}</option>
                    ))}
                </select>


                {isAmateur && (
                    <input
                        className="register-inputs"
                        name="amateur_league"
                        value={details.amateur_league || ""}
                        placeholder={
                            t("clubForm.amateurLeague")
                        }
                        onChange={handleDetailsChange}
                        required
                    />
                )}


                {isProfessional && (
                    <SearchableCountrySelect
                        required
                        className="register-select"
                        value={footballCountry}
                        onChange={(e) => {

                            setFootballCountry(
                                e.target.value
                            );

                            setDetails(prev => ({
                                ...prev,

                                football_country:
                                    e.target.value,

                                league_id: null,
                                league_name: null,
                                season: null,
                                team_id: null,
                                team_name: null,
                            }));

                            setLeagues([]);
                        }}
                    >

                        <option value="">
                            {t("athleteForm.footballCountry")}
                        </option>

                        {countries.map((c) => (
                            <option
                                key={c.code}
                                value={c.name}
                            >
                                {c.flag} {c.name}
                            </option>
                        ))}

                    </SearchableCountrySelect>
                )}


                {isProfessional && (
                    <>
                        {loadingLeagues && (
                            <div className="loading-hint">
                                {t("athleteForm.loadingLeagues")}
                            </div>
                        )}

                        {leagues.length > 0 && (
                            <select
                                required
                                className="register-select"
                                onChange={(e) => {
                                    const selected = e.target.options[e.target.selectedIndex];

                                    const leagueId = selected.value;
                                    const leagueName = selected.dataset.name;
                                    const season = selected.dataset.season;

                                    setLeague(leagueId);

                                    setDetails(prev => ({
                                        ...prev,
                                        league_id: leagueId,
                                        league_name: leagueName,
                                        season: season,
                                    }));
                                }}
                            >
                                <option value="">
                                    {t("clubForm.league")}
                                </option>
                                {leagues.map(l => (
                                    <option
                                        key={l.id}
                                        value={l.id}
                                        data-name={l.name}
                                        data-season={l.season}
                                    >
                                        {l.name}
                                    </option>
                                ))}
                            </select>
                        )}
                    </>
                )
                }
            </>
        </form>
    );
}
